module.exports = __webpack_public_path__ + "static/sadanah-logo-91a601f83ff5ed2eea5d61188c1d154a.png";